import { gql } from "@apollo/client";

// Customer Portal Auth - Lookup account by phone or email
export const cpLookupAccount = gql`
  mutation cpLookupAccount(
    $company_id: String!
    $identifier: String!
    $channel: String!
  ) {
    cpLookupAccount(
      company_id: $company_id
      identifier: $identifier
      channel: $channel
    ) {
      success
      application_id
      phone
      email
      masked_phone
      masked_email
      error
    }
  }
`;

// Customer Portal Auth - Send verification code
export const cpSendVerification = gql`
  mutation cpSendVerification($application_id: String!, $channel: String!) {
    cpSendVerification(application_id: $application_id, channel: $channel) {
      success
      channel
      masked_destination
      error
    }
  }
`;

// Customer Portal Auth - Verify code and get JWT token
export const cpVerifyCode = gql`
  mutation cpVerifyCode(
    $application_id: String!
    $code: String!
    $channel: String!
  ) {
    cpVerifyCode(
      application_id: $application_id
      code: $code
      channel: $channel
    ) {
      success
      token
      error
    }
  }
`;

// ============================================
// Customer Portal Admin Masquerade Mutations
// ============================================

// Admin Login - Authenticate super admin with email/password
export const cpAdminLogin = gql`
  mutation cpAdminLogin($email: String!, $password: String!) {
    cpAdminLogin(email: $email, password: $password) {
      success
      user_id
      email
      phone
      name
      error
    }
  }
`;

// Admin Send Verification - Send 2FA code to admin
export const cpAdminSendVerification = gql`
  mutation cpAdminSendVerification($user_id: String!, $channel: String!) {
    cpAdminSendVerification(user_id: $user_id, channel: $channel) {
      success
      channel
      masked_destination
      error
    }
  }
`;

// Admin Verify Code - Verify 2FA and get temporary admin token
export const cpAdminVerifyCode = gql`
  mutation cpAdminVerifyCode(
    $user_id: String!
    $code: String!
    $channel: String!
  ) {
    cpAdminVerifyCode(user_id: $user_id, code: $code, channel: $channel) {
      success
      token
      error
    }
  }
`;

// Admin Search Applications - Search subscribed applications
export const cpAdminSearchApplications = gql`
  mutation cpAdminSearchApplications(
    $token: String!
    $company_id: String!
    $search: String!
    $limit: Int
  ) {
    cpAdminSearchApplications(
      token: $token
      company_id: $company_id
      search: $search
      limit: $limit
    ) {
      success
      applications {
        id
        short_id
        unique_id
        first_name
        last_name
        email
        phone
        status
        company_id
      }
      total
      error
    }
  }
`;

// Admin Masquerade - Log in as a customer
export const cpAdminMasquerade = gql`
  mutation cpAdminMasquerade($token: String!, $application_id: String!) {
    cpAdminMasquerade(token: $token, application_id: $application_id) {
      success
      token
      application_id
      error
    }
  }
`;

// ============================================
// Company Admin Preview Mutations
// ============================================

// Exchange preview token for customer portal session
export const cpExchangePreviewToken = gql`
  mutation cpExchangePreviewToken($preview_token: String!) {
    cpExchangePreviewToken(preview_token: $preview_token) {
      success
      token
      application_id
      error
    }
  }
`;

// ============================================
// Customer Portal Payment
// ============================================

export const cpProcessPortalPayment = gql`
  mutation cpProcessPortalPayment(
    $token: String!
    $payment_id: String!
    $payment_type: String!
    $account_number: String
    $routing_number: String
    $account_type: String
    $cc_name: String
    $cc_number: String
    $cc_exp: String
    $cc_cvc: String
  ) {
    cpProcessPortalPayment(
      token: $token
      payment_id: $payment_id
      payment_type: $payment_type
      account_number: $account_number
      routing_number: $routing_number
      account_type: $account_type
      cc_name: $cc_name
      cc_number: $cc_number
      cc_exp: $cc_exp
      cc_cvc: $cc_cvc
    ) {
      success
      error_message
      masked_account
      payment_method_type
    }
  }
`;
